import { render, staticRenderFns } from "./ReportDashboard.vue?vue&type=template&id=15a618f1&"
import script from "./ReportDashboard.vue?vue&type=script&lang=js&"
export * from "./ReportDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ReportDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports